export default "__VITE_ASSET__DT3NQMDS__"